import React from 'react';
import { List, Pagination } from 'antd';
import config from 'appConfig';

import styles from './listSavedSearchMobile.scss';
import SavedSearchItem from './SavedSearchItem';
import { calculateTotalPagingCount } from '../../../../services';

const ListSavedSearchMobile = ({
  savedSearches,
  onDelete,
  onNotificationChange,
  onPageChange,
}) => (
  <div className={styles.container}>
    <List
      itemLayout="horizontal"
      dataSource={savedSearches && savedSearches.data ? savedSearches.data : []}
      renderItem={item => (
        <SavedSearchItem
          item={item}
          onDelete={onDelete}
          onNotificationChange={onNotificationChange}
        />
      )}
    />
    {savedSearches && savedSearches.count > config.maxSavedSearchPerPage ? (
      <div className={styles.pagination}>
        <Pagination
          total={calculateTotalPagingCount(savedSearches.count, savedSearches.page)}
          current={savedSearches.page}
          pageSize={config.maxSavedSearchPerPage}
          onChange={onPageChange}
        />
      </div>
    ) : null}
  </div>
);

ListSavedSearchMobile.defaultProps = {
  savedSearches: {},
};

export default ListSavedSearchMobile;



// WEBPACK FOOTER //
// ./src/containers/SavedSearchPage/ListSavedSearch/ListSavedSearchMobile/index.tsx